import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useActions, useTypedSelector } from '../../hooks';
import { indexedDBInstance } from '../../indexedDB';

const AuthenticatorHelper = () => {
  let history = useHistory();
  const authenticating = useTypedSelector(({ session }) => {
    return session.authenticating;
  });
  const needsLogin = useTypedSelector(({ session }) => {
    return session.needsLogin;
  });
  const needsSessionOpen = useTypedSelector(({ session }) => {
    return session.needsSessionOpen;
  });
  const tokenExpired = useTypedSelector((state) => {
    return state.session.tokenExpired;
  });
  const token = useTypedSelector((state) => {
    return state.session.dhlApiToken;
  });
  const { sessionAuthentication, sessionNeedsLogin } = useActions();
  useEffect(() => {
    const login = async () => {
      let username = await indexedDBInstance.getItem('username');
      let password = await indexedDBInstance.getItem('password');
      if (typeof username === 'string' && typeof password === 'string') {
        sessionAuthentication(username, password);
      } else {
        sessionNeedsLogin();
      }
    };
    if (authenticating) {
      history.replace('/');
      login();
    }
  }, [history, authenticating, sessionAuthentication, sessionNeedsLogin]);
  useEffect(() => {
    const openSession = async () => {
      let username = await indexedDBInstance.getItem('username');
      let password = await indexedDBInstance.getItem('password');
      let installationId = await indexedDBInstance.getItem('installationId');
      if (
        typeof username === 'string' &&
        typeof password === 'string' &&
        typeof installationId === 'string'
      ) {
        console.log('auth');
        sessionAuthentication(username, password, installationId, token);
      } else {
        console.log('authFailed');

        sessionNeedsLogin();
      }
    };
    if (needsSessionOpen && !needsLogin) {
      console.log('OpeningSess');

      openSession();
    }
  }, [
    needsSessionOpen,
    token,
    needsLogin,
    sessionAuthentication,
    sessionNeedsLogin,
  ]);
  //Token renewal
  useEffect(() => {
    const refreshToken = async () => {
      let username = await indexedDBInstance.getItem('username');
      let password = await indexedDBInstance.getItem('password');
      if (typeof username === 'string' && typeof password === 'string') {
        sessionAuthentication(username, password);
      } else {
        sessionNeedsLogin();
      }
    };
    if (tokenExpired) {
      refreshToken();
    }
  }, [tokenExpired, sessionAuthentication, sessionNeedsLogin]);
  return <></>;
};

export { AuthenticatorHelper };
